import { render, staticRenderFns } from "./PmauActionPlan.vue?vue&type=template&id=4983e19d&scoped=true&"
import script from "./PmauActionPlan.vue?vue&type=script&lang=js&"
export * from "./PmauActionPlan.vue?vue&type=script&lang=js&"
import style0 from "./PmauActionPlan.vue?vue&type=style&index=0&id=4983e19d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4983e19d",
  null
  
)

export default component.exports